import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import styles from './Layout.module.css';

interface LayoutProps {
  children?: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className={styles.layoutContainer}>
      <div className={styles.content}>
        {children || <Outlet />}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
